import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { FC } from 'react';
import CboardIcon from './assets/cboard-button.svg';

import mixpanel from 'mixpanel-browser';

const EVENT_NAME = 'Therapy_SkillsUI_Dashboard_Click';

const StyledLink = styled(Link)(({ theme }) => {
  const { color, shadow, type } = theme;

  return `
    background: ${color.grayscale[1000]};
    padding: 20px 32px 20px 24px;
    border-radius: 16px;
    box-shadow: ${shadow.regular};
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    height: 100%;
    font-size: ${type.size.regular};
    font-weight: ${type.weight.bold};
    color: ${color.grayscale['0']};

    &:hover {
      color: ${color.grayscale[1000]};
      text-decoration: none;
      background: ${color.secondary.regular};
    }

    @media screen and (min-width: 1024px) and (max-width: 1279px) {
      padding: 20px 16px 20px 12px;
    }
  `;
});

const Img = styled.img`
  display: inline-block;
  max-width: 64px;
  width: 15%;
`;

const SectionText = styled.div(({ theme }) => {
  const { type } = theme;

  return `
    display: inline-block;
    flex-grow: 2;
    font-size: ${type.size.regular};
    font-weight: ${type.weight.bold};
    margin-left: 1rem;
  `;
});

const CboardButton: FC = () => {
  const handleClick = () => {
    mixpanel.track(EVENT_NAME, { Action: 'CommunicationBoard' });
  };

  return (
    <StyledLink onClick={handleClick} to={{ pathname: `/communication-board`, state: { from: location.pathname } }}>
      <Img src={CboardIcon} alt="" />
      <SectionText>Communication Board</SectionText>
    </StyledLink>
  );
};

export default CboardButton;
